import React from 'react';
import { Link } from 'react-router-dom';

const BlogCard = ({ blog }) => {
  const { id, image, title, createdAt, likes, isSaved, tags } = blog;

  const tagContent = tags.map((tag, idx) => {
    if (tags.length === idx + 1) return <span key={idx}>#{tag}</span>;
    return <span key={idx}>#{tag},</span>;
  });

  return (
    <div className="lws-card">
      <Link to={`/blogs/${id}`}>
        <img src={image} className="lws-card-image" alt={title} />
      </Link>
      <div className="p-4">
        <div className="lws-card-header">
          <p className="lws-publishedDate">{createdAt}</p>
          <p className="lws-likeCount">
            <i className="fa-regular fa-thumbs-up"></i>
            {likes}
          </p>
        </div>
        <Link to={`/blogs/${id}`} className="lws-postTitle">
          {title}
        </Link>
        <div className="lws-tags">{tagContent}</div>

        <div className="flex gap-2 mt-4">
          {isSaved && <span className="lws-badge"> Saved </span>}
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
